<template>
	<div class="ww">
		<PageIntroSection :small-title="$t('nav_works').toLowerCase()">
			<template slot="left">
				<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_MEDIUM"
				         :text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT" :scroll-animation-delay=".25">Motion<br>Stars</rr-animate-text>
			</template>
			<template slot="right">
				<div class="aw">
					<div>
						<rr-animate-image file-name="behance-award.svg" :scroll-animation-delay=".25"></rr-animate-image>
						<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_SECONDARY_MEDIUM"
						         :text-color="$const.HTML_CLASS.TEXT_COLOR.GRAY" :scroll-animation-delay=".3">Mo</rr-animate-text>
					</div>
					<div>
						<rr-animate-image file-name="behance-award.svg" :scroll-animation-delay=".3"></rr-animate-image>
						<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_SECONDARY_MEDIUM"
						         :text-color="$const.HTML_CLASS.TEXT_COLOR.GRAY" :scroll-animation-delay=".35">Ae</rr-animate-text>
					</div>
				</div>
			</template>
		</PageIntroSection>
		<rr-section>
			<container-inner>
				<rr-animate-video video-id="283912395" poster-file-name="motion-stars-img-1.jpg"/>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-two-cols :sec-title="$t('case_about')">
				<template slot="content">
					<column :width="3">
						<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_LARGE"
						                 :scroll-animation-delay=".15" v-html="$t('motion_stars_text_1')"/>
						<rr-animate-text class="lw" :text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL"
						                 :text-color="$const.HTML_CLASS.TEXT_COLOR.APP_SECONDARY">
							<span v-for="(h, i) in $t('motion_stars_hashtags').split(',')" :key="'h'+i">#{{ h }}</span>
						</rr-animate-text>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section>
			<container-inner>
				<rr-animate-media file-name="motion-stars-video-1.mp4"/>
			</container-inner>
			<container-inner>
				<row>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-2.mp4"/>
					</column>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-3.mp4"
						                  :scroll-animation-delay=".15"/>
					</column>
				</row>
			</container-inner>
			<container-inner>
				<rr-animate-image file-name="motion-stars-img-2.jpg"/>
			</container-inner>
			<container-inner>
				<row>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-4.mp4"/>
					</column>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-5.mp4"
						                  :scroll-animation-delay=".15"/>
					</column>
				</row>
			</container-inner>
			<container-inner>
				<rr-animate-image file-name="motion-stars-img-6.jpg"/>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner :is-fluid="true">
				<rr-slider :slides="gallerySlides1"></rr-slider>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner>
				<rr-animate-image file-name="motion-stars-img-8.jpg"/>
			</container-inner>
			<container-inner>
				<rr-animate-media file-name="motion-stars-video-12.mp4"/>
			</container-inner>
			<container-inner>
				<row>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-13.mp4"/>
					</column>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-14.mp4"
						                  :scroll-animation-delay=".15"/>
					</column>
				</row>
			</container-inner>
			<container-inner>
				<row>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-15.mp4"/>
					</column>
					<column :width="2">
						<rr-animate-media file-name="motion-stars-video-16.mp4"
						                  :scroll-animation-delay=".15"/>
					</column>
				</row>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner :is-fluid="true">
				<rr-slider :slides="gallerySlides2"></rr-slider>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-two-cols :sec-title="$t('case_design')">
				<template slot="content">
					<column :width="2">
						<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_SMALL"
						                 :scroll-animation-delay=".15">{{ $t('motion_stars_title_1') }}
						</rr-animate-text>
						<rr-animate-text v-html="$t('motion_stars_text_2')"/>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section>
			<container-inner>
				<rr-animate-image file-name="motion-stars-img-5.jpg"/>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner :is-fluid="true">
				<rr-slider :slides="gallerySlides4"></rr-slider>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner>
				<rr-animate-image file-name="motion-stars-img-7.jpg"/>
			</container-inner>
			<container-inner>
				<row>
					<column :width="2">
						<rr-animate-image file-name="motion-stars-img-3.jpg"/>
					</column>
					<column :width="2">
						<rr-animate-image file-name="motion-stars-img-4.jpg"
						                  :scroll-animation-delay=".15"/>
					</column>
				</row>
			</container-inner>
		</rr-section>
		<rr-section>
			<container-inner :is-fluid="true">
				<rr-slider :slides="gallerySlides5"></rr-slider>
			</container-inner>
		</rr-section>
		<rr-section :background-color="$const.HTML_CLASS.BACKGROUND_COLOR.TRANSPARENT">
			<container-two-cols :is-dark-title="false" :sec-title="$t('case_credits_1')">
				<template slot="content">
					<column>
						<rr-animate-text :text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT"
						                 :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_SMALL"
						                 :scroll-animation-delay=".15">{{  $t('case_credits_2') }}
						</rr-animate-text>
						<rr-table :rows="creditsTableRows" :columns="creditsTableColumns"/>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section>
			<container-two-cols :sec-title="$t('next_work')">
				<template slot="content">
					<column>
						<rr-animate-link-wrap href="/works/digital-ocean"
						                      :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
						                      :text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_DARK"
						                      :scroll-animation-delay=".15">Digital<br>Ocean&nbsp;<span v-html="require('!svg-inline-loader!@/assets/img/svg/link-arrow.svg')"/>
						</rr-animate-link-wrap>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
	</div>
</template>

<script>
import PageIntroSection from '../../components/page/PageIntroSection'
import appearAfterLoadingAnimation from '../../mixins/animations/appear-after-loading'

export default {
	name: 'case-motion-stars',
	components: {
		PageIntroSection,
		// CreditsTable,
		// WorksStatic,
		// BadgeWrapper,
		// Video,
	},
	metaInfo() {
		return {
			title: 'Motion Stars'
		}
	},
	data() {
		return {
			// slider
			gallerySlides1: [
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-6.mp4',
					},
				},
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-7.mp4',
						scrollAnimationDelay: .23,
					},
				},
			],
			gallerySlides4: [
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-9.mp4',
					},
				},
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-10.mp4',
						scrollAnimationDelay: .23,
					},
				},
			],
			gallerySlides5: [
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-11.mp4',
						scrollAnimationDelay: .46,
					},
				},
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-8.mp4',
						scrollAnimationDelay: .46,
					},
				},
			],
			gallerySlides2: [
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-17.mp4',
					},
				},
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-18.mp4',
						scrollAnimationDelay: .23,
					},
				},
				{
					component: 'rr-animate-media',
					props: {
						fileName: 'motion-stars-video-19.mp4',
						scrollAnimationDelay: .46,
					},
				},
			],
			// gallerySlides3: [
			// 	{
			// 		component: 'rr-animate-image',
			// 		props: {
			// 			fileName: 'motion-stars-img-5.jpg',
			// 		},
			// 	},
			// 	{
			// 		component: 'rr-animate-image',
			// 		props: {
			// 			fileName: 'motion-stars-img-6.jpg',
			// 			scrollAnimationDelay: .23,
			// 		},
			// 	},
			// 	{
			// 		component: 'rr-animate-image',
			// 		props: {
			// 			fileName: 'motion-stars-img-7.jpg',
			// 			scrollAnimationDelay: .46,
			// 		},
			// 	},
			// 	{
			// 		component: 'rr-animate-image',
			// 		props: {
			// 			fileName: 'motion-stars-img-8.jpg',
			// 			scrollAnimationDelay: .69,
			// 		},
			// 	},
			// ],
			// table
			// columns
			creditsTableColumns: [
				{
					type: 't',
					value: '__key',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.GRAY,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '35%',
						},
					},
				},
				{
					type: 't',
					value: '__value',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.LIGHT,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '65%',
						},
					},
				},
			],
			// rows
			creditsTableRows: [
				{
					key: this.$t('credit_client')+':',
					value: this.$t('motion_stars_client'),
				},
				{
					key: this.$t('credit_art_director')+':',
					value: this.$t('motion_stars_art_director'),
				},
				{
					key: this.$t('credit_animation')+':',
					value: this.$t('motion_stars_animation'),
				},
				{
					key: this.$t('credit_illustrations_character')+':',
					value: this.$t('motion_stars_illustrations_character'),
				},
				{
					key: this.$t('credit_sounds')+':',
					value: this.$t('motion_stars_sounds'),
				},
			],
		}
	},
	mixins: [appearAfterLoadingAnimation],
}
</script>
